// Imports




// Stateful components

export class MIPN extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            selected_program: null
        };
    }

    componentDidMount(){
        var this_component = this;
        this_component.getProgramData();
    }


    //
    // Functions
    //

    getProgramData() {
        var this_component = this;

        var courses_storage = squiz.fn.getStorage('getmycourses', 'session', 'json');

        var programs = courses_storage['data']['programs'];
        var programs_index = this_component['props']['index'];
        var selected_program = programs[programs_index];
        
        if (selected_program) {
            this_component.setState({
                selected_program: selected_program
            });
        }
    }

    renderMIPN() {
        var this_component = this;
        var selected_program = this_component['state']['selected_program'];

        if (selected_program) {
            if (selected_program.externalSystem) {

                if (selected_program.externalSystem.value) {
                
                    return (
                        <div className="mipn__wrapper">
                            <span className="mipn__label">Medical Intern Placement Number</span><span className="mipn__value">{selected_program.externalSystem.id}</span>
                        </div>
                    );

                }
                
            }
        }
        
        return null;
    }


    //
    // Render
    //

    render() {
        var this_component = this;
        
        return (
            <>
            {this_component.renderMIPN()}
            </>
        );
    }

};
